module.exports = __webpack_public_path__ + "img/23.fb487b2f.svg";